// extracted by mini-css-extract-plugin
export default {"harvestForc":"footer_harvestForc__-N9k1","socialIcons":"footer_socialIcons__q7Eke","links":"footer_links__bXG+P"};